import { gql } from 'graphql-request';

// ==================== FRAGMENTS ====================

export const GEOFENCE_CATEGORY_FIELDS = gql`
  fragment GeofenceCategoryFields on GeofenceCategoryDto {
    geofenceCategoryId
    name
    description
    icon
    color
    isActive
    isGlobal
    sortOrder
    organizationId
    createdAt
    updatedAt
  }
`;

export const GEOFENCE_FIELDS = gql`
  fragment GeofenceFields on GeofenceDto {
    geofenceId
    name
    description
    color
    isActive
    geofenceCategoryId
    organizationId
    projectId
    warehouseId
    createdAt
    updatedAt
    shape {
      type
      radiusMeters
      center {
        lat
        lng
      }
      polygonCoordinates {
        lat
        lng
      }
    }
  }
`;

export const GEOFENCE_WITH_RELATIONS_FIELDS = gql`
  fragment GeofenceWithRelationsFields on GeofenceDto {
    ...GeofenceFields
    category {
      ...GeofenceCategoryFields
    }
    project {
      projectId
      name
    }
    warehouse {
      warehouseId
      name
    }
  }
  ${GEOFENCE_FIELDS}
  ${GEOFENCE_CATEGORY_FIELDS}
`;

// ==================== GEOFENCE CATEGORY — QUERIES ====================

export const getGeofenceCategories = gql`
  query getGeofenceCategories {
    getGeofenceCategories {
      ...GeofenceCategoryFields
    }
  }
  ${GEOFENCE_CATEGORY_FIELDS}
`;

export const getActiveGeofenceCategories = gql`
  query getActiveGeofenceCategories {
    getActiveGeofenceCategories {
      ...GeofenceCategoryFields
    }
  }
  ${GEOFENCE_CATEGORY_FIELDS}
`;

export const getGlobalGeofenceCategories = gql`
  query getGlobalGeofenceCategories {
    getGlobalGeofenceCategories {
      ...GeofenceCategoryFields
    }
  }
  ${GEOFENCE_CATEGORY_FIELDS}
`;

export const getGeofenceCategory = gql`
  query getGeofenceCategory($geofenceCategoryId: String!) {
    getGeofenceCategory(geofenceCategoryId: $geofenceCategoryId) {
      ...GeofenceCategoryFields
    }
  }
  ${GEOFENCE_CATEGORY_FIELDS}
`;

// ==================== GEOFENCE CATEGORY — MUTATIONS ====================

export const createGeofenceCategory = gql`
  mutation createGeofenceCategory($category: GeofenceCategoryCreateInput!) {
    createGeofenceCategory(category: $category) {
      ...GeofenceCategoryFields
    }
  }
  ${GEOFENCE_CATEGORY_FIELDS}
`;

export const updateGeofenceCategory = gql`
  mutation updateGeofenceCategory($category: GeofenceCategoryUpdateInput!) {
    updateGeofenceCategory(category: $category) {
      ...GeofenceCategoryFields
    }
  }
  ${GEOFENCE_CATEGORY_FIELDS}
`;

export const updateGeofenceCategorySortOrder = gql`
  mutation updateGeofenceCategorySortOrder($categoryIds: [String!]!) {
    updateGeofenceCategorySortOrder(categoryIds: $categoryIds) {
      ...GeofenceCategoryFields
    }
  }
  ${GEOFENCE_CATEGORY_FIELDS}
`;

export const deleteGeofenceCategory = gql`
  mutation deleteGeofenceCategory($geofenceCategoryId: String!) {
    deleteGeofenceCategory(geofenceCategoryId: $geofenceCategoryId) {
      affected
    }
  }
`;

// ==================== GEOFENCE — QUERIES ====================

export const getGeofences = gql`
  query getGeofences($filter: GeofenceFilterInput) {
    getGeofences(filter: $filter) {
      ...GeofenceWithRelationsFields
    }
  }
  ${GEOFENCE_WITH_RELATIONS_FIELDS}
`;

export const getGeofence = gql`
  query getGeofence($geofenceId: String!) {
    getGeofence(geofenceId: $geofenceId) {
      ...GeofenceWithRelationsFields
    }
  }
  ${GEOFENCE_WITH_RELATIONS_FIELDS}
`;

// ==================== GEOFENCE — MUTATIONS ====================

export const createGeofence = gql`
  mutation createGeofence($input: GeofenceCreateInput!) {
    createGeofence(input: $input) {
      ...GeofenceWithRelationsFields
    }
  }
  ${GEOFENCE_WITH_RELATIONS_FIELDS}
`;

export const updateGeofence = gql`
  mutation updateGeofence($input: GeofenceUpdateInput!) {
    updateGeofence(input: $input) {
      ...GeofenceWithRelationsFields
    }
  }
  ${GEOFENCE_WITH_RELATIONS_FIELDS}
`;

export const setGeofenceActive = gql`
  mutation setGeofenceActive($geofenceId: String!, $isActive: Boolean!) {
    setGeofenceActive(geofenceId: $geofenceId, isActive: $isActive) {
      ...GeofenceWithRelationsFields
    }
  }
  ${GEOFENCE_WITH_RELATIONS_FIELDS}
`;

export const deleteGeofence = gql`
  mutation deleteGeofence($geofenceId: String!) {
    deleteGeofence(geofenceId: $geofenceId) {
      affected
    }
  }
`;

// ==================== EXPORT BUNDLE ====================

const GeofenceGraphQL = {
  queries: {
    // Categories
    getGeofenceCategories,
    getActiveGeofenceCategories,
    getGlobalGeofenceCategories,
    getGeofenceCategory,
    // Geofences
    getGeofences,
    getGeofence,
  },
  mutations: {
    // Categories
    createGeofenceCategory,
    updateGeofenceCategory,
    updateGeofenceCategorySortOrder,
    deleteGeofenceCategory,
    // Geofences
    createGeofence,
    updateGeofence,
    setGeofenceActive,
    deleteGeofence,
  },
};

export default GeofenceGraphQL;
